import { Component, OnInit, OnDestroy, ViewContainerRef } from '@angular/core';
import { ITdDynamicElementConfig, TdDynamicElement, TdDynamicType } from '@covalent/dynamic-forms';
import { TdFileService, IUploadOptions, ITdDataTableColumn, TdDataTableSortingOrder, TdDataTableService, TdDialogService, IPageChangeEvent, ITdDataTableSortChangeEvent, TdLoadingService } from '@covalent/core';
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { SalesService } from '../sales.service';
import { InventoryService } from '../../inventory/inventory.service';
import { Piece } from '../../inventory/piece';
import { Branch } from '../../accounting/branch';
import { PoService } from '../../purchasing/pos/po.service';
import { PoBranch } from '../../purchasing/pos/poBranch';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { BranchService } from '../../accounting/branches/branch.service';
import { CustomerService } from '../../accounting/customer/customer.service';
import { User } from '../../../shared/classes/user';
import { Customer } from '../../accounting/customer';
import { SettingsService } from '../../../shared/services/settings.service';
import { ReportService } from '../../../shared/services/report.service';
import { BackOrder } from '../backorder';
import { BackorderItem } from '../backorder-item';
import { Utils } from '../../../shared/utils';
import { Product } from '../../../agatextscreens/purchasing/products/product';
import { ProductService } from '../../../agatextscreens/purchasing/products/product.service';

@Component({
  selector: 'app-backorder',
  templateUrl: './backorder.component.html',
  styleUrls: ['./backorder.component.scss'],
  providers: [CustomerService, ReportService, ProductService]
})
export class BackorderComponent implements OnInit, OnDestroy {
  _loading: number = 0;

  _selectAll: boolean;
  _change_b2b_mode: boolean = false;

  data: BackOrder;
  currentBo: BackOrder = new BackOrder();

  originalBo: BackOrder = new BackOrder();

  valid_BackOrdersmen: string[] = [];

  subscription: Subscription = new Subscription();
  title: string;

  allBranches: Branch[];
  filteredBranches: Branch[];

  selectedCustomer: Customer;
  cust: any;

  allCustomers: Customer[] = [];
  matchingCustomers: Customer[] = [];

  //  allCustomers: Customer[];
  //  filteredCustomers: Customer[];

  allProducts: Product[] = [];
  matchingProducts: Product[] = [];
  selectedProduct: Product;

  availableStatuses: string[];

  allTypes$: Observable<string[]>;
  isEditMode: boolean;

  existingInventory: Piece[];

  totalPiecesValue: number = 0;
  totalQtyValue: number = 0;
  totalValue: number = 0;
  totalMetersValue: number = 0;
  totalPriceByRowValue: number = 0;
  totalPriceByAllRowsValue: number = 0;
  discount: number = 10;
  shippingCharges: number = 100;
  totals: number = 0;
  totalUnitPrices: number = 0;


  columns: ITdDataTableColumn[] = [
    { name: 'collection', label: 'Collection', tooltip: 'some tooltip example' },
    { name: 'designColor', label: 'Design / Color' },
    { name: 'quantity', label: 'QTY (M)' },
    { name: 'unit_price', label: 'Unit Price' },
  ];

  // Selected Items
  meters: number;
  unitPriceCAD: number;

  items: BackorderItem[] = [];

  // Current Inventory
  filteredData: any[] = [];
  filteredTotal: number;
  searchTerm: string;
  fromRow: number = 1;
  currentPage: number = 1;
  sortBy: string = 'id';
  selectedRows: any[];
  sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Ascending;

  // Currency Symbol for displays
  _currency_symbol: string;

  constructor(private _salesService: SalesService,
    private _customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router,
    private _dataTableService: TdDataTableService,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _settingsService: SettingsService,
    private _viewContainerRef: ViewContainerRef,
    private _branchService: BranchService,
    private _productService: ProductService,
    private location: Location,
    public _authService: AuthenticationService) { }

  ngOnInit(): void {
    this.setLoading(true, 'loading');

    this.subscription.add(this._productService
      .getProducts()
      .subscribe((products: Product[]) => {
        this.allProducts = products;
        this.matchingProducts = products.slice(0, 100);

        //this._loadingService.resolve('loading');
      })
    );

    this.route.paramMap
      .switchMap((params: ParamMap) => params.get('id')
        ? this.processEditBackOrder(params.get('id'))
        : this.processNewBackOrder())
      .subscribe((currentItem: BackOrder) => {
        this.currentBo = currentItem;
        // If it was an existing BackOrder retrieve items
        if (this.currentBo.id != null) {
          this.title = this.currentBo.order_number;
          this.originalBo = Object.assign({}, this.currentBo);
          this.cust = this.currentBo.customer_prefix + ' - ' + this.currentBo.customer_name;

          this._salesService.getBackOrderItems(this.currentBo.id + '').subscribe(
            response => {
              this.items = response;
              this.filter();
            }
          );

        } else {
          // This one's new. Set default branch on load
          this.currentBo.branch_id = this._authService.getHomeBranch();
          // And its tax
          this.updateTax(this.currentBo.branch_id);
          // load available customers
          this.loadCustomers();
        }

        this.setLoading(false, 'loading');
        this.availableStatuses = this.getAvailableStatuses();

        this.filterSalesmen();
      });

    //this.allCustomers$ = this._BackOrdersService.getCustomerPrefixes();

    /*
    this._salesService.getCustomerPrefixes().subscribe(
      response => {
        this.allCustomers = response;
        this.filteredCustomers = response;
      }
    );
    */

    this.availableStatuses = this.getAvailableStatuses();

    this.allTypes$ = this._salesService.getTypes();
    this.allBranches = this._authService.getUserBranches();

    this.filteredBranches = this.allBranches;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  loadCustomers() {
    this.clearSelectedCustomer();
    console.log('getting customers for branch: ' + this.currentBo.branch_id);

    this.subscription.add(
      this._customerService
        .getCustomersPerBranch(this.currentBo.branch_id + '').subscribe(
          (response: { id: string, customers: Customer[] }) => {
            this.allCustomers = response.customers;
            this.matchingCustomers = response.customers.slice(0, 100);
          })
    );
  }


  setSelectedCustomer(customer: Customer) {
    // set the customer
    this.selectedCustomer = customer;

    this.currentBo.customer_id = Number.parseInt(customer.id);
    this.currentBo.customer_name = customer.name;
    this.currentBo.customer_prefix = customer.prefix;

    // set the salesman
    this.getSalesman(customer.id);
  }

  clearSelectedCustomer() {
    this.selectedCustomer = null;
    this.cust = '';

    this.currentBo.customer_id = null;
    this.currentBo.customer_name = null;
    this.currentBo.customer_prefix = null;

    this.currentBo.salesman = null;
  }

  // Filter based on user input
  filterCustomers(input: string) {
    console.log('input: ' + input);

    this.currentBo.branch_id

    this.matchingCustomers = this.allCustomers.filter(
      (cust: Customer) => {
        let full_name = cust.prefix + ' - ' + cust.name;
        return full_name.toLowerCase().includes(input.toLowerCase());
      }
    ).slice(0, 100); // limit the matches to 100
  }



  setSelected(product: Product) {
    this.selectedProduct = product;
  }


  filterProducts(input: string) {
    console.log('input: ' + input);

    this.matchingProducts = this.allProducts.filter(
      (prod: Product) => {
        let full_name = prod.collection_name + ' - ' + prod.design_name + '/' + prod.name;
        return full_name.toLowerCase().includes(input.toLowerCase());
      }
    ).slice(0, 100);

  }

  setLoading(loading: boolean, name: string) {
    if (loading) {
      this._loadingService.register(name);
      this._loading++;
    }
    else {
      this._loadingService.resolve(name);
      this._loading--;
    }
  }

  isLoading(): boolean {
    return this._loading > 0;
  }

  addItemToList() {
    let message: string[] = [];

    if (this.selectedProduct == null) {
      message.push('Please select a Collection - Design/Color in order to add items to the list.')
    }

    if (this.meters == null) {
      message.push('Please enter the meterage in order to add items to the list.')
    }

    if (this.unitPriceCAD == null) {
      message.push('Please enter the unit price in order to add items to the list.')
    }

    if (message.length > 0) {
      this._dialogService.openAlert({
        title: 'Missing information',
        message: message.join(' ')
      })
      return;
    }

    // If the product is already in the list, prevent it from going in again
    if (this.items.some((p) => { return p.color_id == this.selectedProduct.id })) {
      this._dialogService.openAlert({
        title: 'Duplicated Product',
        message: 'The selected product already exists in the product list'
      })
      return;
    }

    this.items.push({
      collection_id: this.selectedProduct.collection_id,
      collection_name: this.selectedProduct.collection_name,
      color_id: this.selectedProduct.id,
      color_name: this.selectedProduct.name,
      design_name: this.selectedProduct.design_name,
      quantity: this.meters,
      unit_price: this.unitPriceCAD,
    });

    this.filter();
  }

  filterSalesmen() {
    console.log(this.currentBo.branch_id);
    this._salesService.getUsersPerBranch(this.currentBo.branch_id + '').subscribe(
      response => {
        if (Array.isArray(response)) {
          this.valid_BackOrdersmen = response.map(i => i.first_name + ' ' + i.last_name);
        } else {
          this.valid_BackOrdersmen = [];
        }
      }
    );
  }

/*
  filterCustomers() {
    this._customerService.getCustomersPerBranch(this.currentBo.branch_id + '').subscribe(
      (response: { id: string, customers: Customer[] }) => {
        this.filteredCustomers = response.customers.filter(
          (c: Customer) => {
            return this.allCustomers.some(
              (_c: Customer) => {
                return c.id == _c.id
              }
            );
          }
        );
      }
    );
  }
*/

  filterBranches() {
    this._customerService.getOneCustomerBranches(this.currentBo.customer_id + '').subscribe(
      (response: { id: string, branches: Branch[] }) => {
        this.filteredBranches = response.branches.filter(
          (b: Branch) => {
            return this.allBranches.some(
              (_b: Branch) => {
                return b.id == _b.id
              }
            )
          }
        );
      }
    );
  }

  updateTax($event) {
    this._branchService.getBranch($event).subscribe(
      response => {
        if (response.sales_tax != null) {
          this.currentBo.tax = response.sales_tax;
        }
        if (response.sales_tax2 != null) {
          this.currentBo.tax2 = response.sales_tax2;
        }
        // Update also the currency
        if (response.currency != null) {
          this._currency_symbol = response.currency;
        }
      }
    );
  }

  changed(): boolean {
    for (let prop in this.currentBo) {
      if (this.currentBo[prop] != this.originalBo[prop]) {
        return true;
      }
    }

    return false;
  }

  getSalesman($event) {
    this._customerService.getOneCustomer($event).subscribe(
      response => {
        this.currentBo.salesman = response.sales_person;
      }
    );
  }

  total(data: any[], field: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b[field]) }, 0);
  }

  totalProduct(data: any[], field1: string, field2: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + (Number.parseFloat(b[field1]) * Number.parseFloat(b[field2])) }, 0);
  }

  totalChecked(data: any[], field: string) {
    return data.reduce(function (a, b) { return Number.parseFloat(a) + Number.parseFloat(b['selected'] ? b[field] : 0) }, 0);
  }

  toggleSelectAll(value: boolean) {
    this.filteredData.forEach(
      function (d) {
        d.selected = value;
      }
    );
  }

  shouldSelectAll(): boolean {
    return this.filteredData.filter(
      function (d) {
        return d.selected
      }
    ).length == this.filteredData.length;
  }

  removeItem(id: number) {
    this.items = this.items.filter(
      (t) => {
        if (t.id == id) {
          // Send it back to the queue
          //this.existingInventory.push(t);

          return false;
        } else {
          return true;
        }
      });

    this.filter();
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  page(pagingEvent: IPageChangeEvent): void {
    this.fromRow = pagingEvent.fromRow;
    this.currentPage = pagingEvent.page;
    this._settingsService.setPageSize(pagingEvent.pageSize);
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.existingInventory ? this.existingInventory : [];
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    // Do not display in the inventory the stuff that has been added already
    this.items.forEach(
      (i) => {
        newData = newData.filter((d) => { return d.id != i.id });
      }
    );

    this.filteredTotal = newData.length;
    newData = Utils.sortData(newData, this.sortBy, this.sortOrder);
    if (this._settingsService.getPageSize() + '' != 'All') {
      newData = this._dataTableService.pageData(newData, this.fromRow, this.currentPage * this._settingsService.getPageSize());
    }
    // Sort the inventory based on design/color
    this.filteredData = newData.sort(
      (a, b) => {
        return (a['design_name'] != b['design_name']) ?
          ((a['design_name'] > b['design_name']) ? 1 : -1) :
          ((a['color_name'] > b['color_name']) ? 1 : -1);
      }
    );

  }

  openModifyTax1() {
    this._dialogService.openPrompt({
      message: 'Enter new VAT value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: this.currentBo.tax + '',
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        this.currentBo.tax = Number.parseFloat(newValue);
      } else {
        console.log('No change');
      }
    });
  }

  openModifyTax2() {
    this._dialogService.openPrompt({
      message: 'Enter new VAT value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: this.currentBo.tax2 + '',
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        this.currentBo.tax2 = Number.parseFloat(newValue);
      } else {
        console.log('No change');
      }
    });
  }

  enterNewValueDialog(row: Piece, attr: string) {
    this._dialogService.openPrompt({
      message: 'Enter new value',
      viewContainerRef: this._viewContainerRef,
      title: 'Modify value',
      value: row[attr],
      cancelButton: 'Cancel',
      acceptButton: 'Apply',
    }).afterClosed().subscribe((newValue: string) => {
      if (newValue) {
        row[attr] = newValue;
      } else {
        console.log('DECLINED');
      }
    });
  }

  processEditBackOrder(orderNumber: string): Observable<BackOrder> {
    this.title = 'Edit';
    this.isEditMode = true;
    return this._salesService.getOneBackOrder(orderNumber);
  }

  processNewBackOrder(): Observable<BackOrder> {
    this.title = 'New';
    this.isEditMode = false;
    return Observable.of(new BackOrder());
  }

  createNewBackOrder() {
    this.setLoading(true, 'loading');

    if (!this.currentBo.order_date || !this.currentBo.delivery_date) {
      this._dialogService.openAlert({
        title: 'Missing Data',
        message: "Please Enter an Order Date and Delivery Date",
        closeButton: 'OK'
      })

      this.setLoading(false, 'loading');
      return;
    }

    // Clean slate
    this.currentBo.items = [];
    this.items.forEach(
      (item) => {
        this.currentBo.items.push({
          color_id: item.color_id,
          quantity: item.quantity,
          unit_price: item.unit_price
        });
      }
    );
    // Create the BackOrder
    this._salesService.createBackOrder(this.currentBo).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.currentBo.id = response['id'];
          this.currentBo.order_number = response['order_number'];

          this.originalBo = Object.assign({}, this.currentBo);

          this.isEditMode = true;
          this._dialogService.openAlert({
            message: 'Back Order ' + this.currentBo.order_number + ' created successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/backorder', 'list']);
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not create Back Order ' + this.currentBo.order_number + '.',
            title: 'Failed!',
          });
        }

        this.setLoading(false, 'loading');
      },
      error => {
        this._dialogService.openAlert({
          message: 'Error creating Back Order ' + this.currentBo.order_number + ': ' + error,
          title: 'Error!',
        });
        this.setLoading(false, 'loading');

      },
      () => { }
    );
  }

  updateBackOrder() {
    this.setLoading(true, 'loading');

    // Clean slate
    this.currentBo.items = [];
    this.items.forEach(
      (item) => {
        this.currentBo.items.push({
          color_id: item.color_id,
          quantity: item.quantity,
          unit_price: item.unit_price
        });
      }
    );

    this._salesService.updateBackOrder(this.currentBo.id, this.currentBo).subscribe(
      response => {
        if (response['status'] == 'SUCCESS') {
          this.originalBo = Object.assign({}, this.currentBo);

          this._dialogService.openAlert({
            message: 'Back Order ' + this.currentBo.order_number + ' updated successfully!',
            title: 'Success!',
          }).afterClosed().subscribe((accept: boolean) => {
            this.router.navigate(['/backorder', 'list']);
          });
        } else {
          this._dialogService.openAlert({
            message: 'Could not update Back Order ' + this.currentBo.order_number + '.',
            title: 'Failed!',
          });
        }

        this.setLoading(false, 'loading');

      },
      error => {
        this._dialogService.openAlert({
          message: 'Error updating Back Order ' + this.currentBo.order_number + ': ' + error,
          title: 'Error!',
        });
        this.setLoading(false, 'loading');

      },
      () => { }
    );
  }


  getPrefixForCustomerId(id: number) {
    this.currentBo.customer_prefix = this.allCustomers.find(
      (c) => {
        return Number.parseInt(c.id) == id;
      }
    )['prefix'];
  }

  getTotalMeters(): number {
    let t: number = 0;
    this.items.forEach(
      function (item) {
        t += item.quantity * 1; //The * 1 is to turn the string to number
      }
    );
    return t;
  }

  getTotalValue(): number {
    let t: number = 0;
    this.items.forEach(
      function (item) {
        t += item.quantity * item.unit_price;
      }
    );
    return t;
  }

  goBack(): void {
    this.location.back();
  }

  getAvailableStatuses(): string[] {
    if (this.isEditMode == false) {
      return ['DRAFT', 'APPROVED'];
    }

    switch (this.currentBo.status) {
      // If it was draft, can be DRAFT, RESERVED
      case 'DRAFT':
        return ['DRAFT', 'APPROVED', 'DECLINED'];

      case 'APPROVED':
        return ['APPROVED', 'COMPLETED'];

      // Else you can't move status in here
      default:
        return [this.currentBo.status];
    }

  }

  isDraft(): boolean {
    if (this.currentBo == null) return false;

    switch (this.currentBo.status) {
      case 'DRAFT':
      case 'DECLINED':
      case 'APPROVED':
      case 'COMPLETED':
        return true;
      default:
        return false;
    }
  }

  isDeclined(): boolean {
    if (this.currentBo == null) return false;

    switch (this.currentBo.status) {
      case 'DRAFT':
      case 'APPROVED':
      case 'COMPLETED':
        return false;
      case 'DECLINED':
        return true;
      default:
        return false;
    }
  }

  isApproved(): boolean {
    if (this.currentBo == null) return false;

    switch (this.currentBo.status) {
      case 'DRAFT':
      case 'DECLINED':
        return false;
      case 'APPROVED':
      case 'COMPLETED':
        return true;
      default:
        return false;
    }
  }

  wasApproved(): boolean {
    if (this.originalBo == null) return false;

    switch (this.originalBo.status) {
      case 'DRAFT':
      case 'DECLINED':
        return false;
      case 'APPROVED':
      case 'COMPLETED':
        return true;
      default:
        return false;
    }
  }

  isCompleted(): boolean {
    if (this.currentBo == null) return false;

    switch (this.currentBo.status) {
      case 'DRAFT':
      case 'DECLINED':
      case 'APPROVED':
        return false;
      case 'COMPLETED':
        return true;
      default:
        return false;
    }
  }

  wasCompleted(): boolean {
    if (this.originalBo == null) return false;

    switch (this.originalBo.status) {
      case 'DRAFT':
      case 'DECLINED':
      case 'APPROVED':
        return false;
      case 'COMPLETED':
        return true;
      default:
        return false;
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/sales/backorder/backorder.component.ts